// extracted by mini-css-extract-plugin
export var label = "_fc-2";
export var slideContainer = "_fc-0";
export var slider = "_fc-1";